import React from 'react'
import { Link, Icon } from 'components'
import * as Styles from './Divider.module.css'

const Divider = ({ data }) => {
  return data ? (
    <div className={Styles.divider}>
      <div>
        {data.text}{' '}
        {data.callToAction && (
          <Link className={Styles.link} to="/cases">
            {data.callToAction?.label}
            <Icon className={Styles.icon} name="RiArrowRightSLine" />
          </Link>
        )}
      </div>
    </div>
  ) : (
    <></>
  )
}

export default Divider
